import React from 'react';
import { motion } from 'framer-motion';
import { FaArrowRight, FaHeadset, FaCheckCircle } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import PremiumButton from './ui/PremiumButton';

export default function CTA() {
  return (
    <section id="contact" className="py-32 px-4 relative overflow-hidden">
      <div className="absolute inset-0 pointer-events-none">
        <motion.div
          animate={{ background: ['radial-gradient(circle at 30% 50%, rgba(14,165,233,0.15) 0%, transparent 50%)', 'radial-gradient(circle at 70% 50%, rgba(249,115,22,0.15) 0%, transparent 50%)', 'radial-gradient(circle at 30% 50%, rgba(14,165,233,0.15) 0%, transparent 50%)'] }}
          transition={{ duration: 10, repeat: Infinity }}
          className="absolute inset-0" />
      </div>
      <div className="max-w-6xl mx-auto relative z-10">
        <motion.div initial={{ opacity: 0, scale: 0.95 }} whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }} transition={{ duration: 0.8 }} className="relative">
          <div className="absolute inset-0 bg-gradient-to-br from-cyan-500/10 to-orange-500/10 rounded-[3rem] blur-3xl" />
          <div className="relative bg-gradient-to-br from-gray-50/80 dark:from-gray-900/80 to-white/80 dark:to-black/80 p-12 md:p-20 rounded-[3rem] border border-cyan-500/20 backdrop-blur-md overflow-hidden">
            <div className="absolute inset-0 overflow-hidden opacity-10">
              {[...Array(5)].map((_, i) => (
                <motion.div key={i} animate={{ x: ['-100%', '100%'] }}
                  transition={{ duration: 10 + i * 2, repeat: Infinity, delay: i * 0.5 }}
                  className="absolute h-px bg-gradient-to-r from-transparent via-cyan-500 to-transparent"
                  style={{ top: `${20 + i * 20}%`, width: '100%' }} />
              ))}
            </div>
            <div className="relative z-10 text-center">
              <h2 className="text-5xl md:text-7xl lg:text-8xl font-black mb-8 leading-tight">
                Ready to <span className="bg-gradient-to-r from-cyan-400 to-orange-500 bg-clip-text text-transparent">10x</span> Your Growth?
              </h2>
              <p className="text-xl md:text-2xl text-gray-700 dark:text-gray-300 mb-12 max-w-3xl mx-auto leading-relaxed font-light">
                Join 500+ successful businesses that transformed their digital presence and achieved remarkable growth with BottomFunnel.
              </p>
              <div className="flex flex-col sm:flex-row gap-6 justify-center items-center mb-12">
                <PremiumButton primary large icon={<FaArrowRight />}>Start Your Transformation</PremiumButton>
                <Link to="/contact">
                  <PremiumButton large icon={<FaHeadset />}>Book Free Consultation</PremiumButton>
                </Link>
              </div>
              <div className="flex flex-wrap items-center justify-center gap-8 text-gray-600 dark:text-gray-400">
                {['Free Strategy Session', 'No Payment Required', 'ROI Guarantee'].map((text, i) => (
                  <motion.div key={i} whileHover={{ scale: 1.05 }} className="flex items-center gap-3">
                    <FaCheckCircle className="text-green-500 text-xl" />
                    <span className="text-base font-medium">{text}</span>
                  </motion.div>
                ))}
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
